import type { ItandiAccount } from "./ItandiAccount";

export type StaffAuthorization = {
	enableCancel: boolean;
	enableCompleteStatus: boolean;
	enableSetting: boolean;
	enableStatus: boolean;
	id: number;
};

export type StaffAuthParam = Omit<StaffAuthorization, "id">;

export const buildDefaultStaffAuth = (): StaffAuthParam => ({
	enableCancel: true,
	enableCompleteStatus: true,
	enableSetting: true,
	enableStatus: true
});

type AuthorizationType =
	| "enableStatus"
	| "enableCancel"
	| "enableSetting"
	| "enableCompleteStatus";

export const AUTH_NAME = {
	cancel: "staffAuthorization.enableCancel",
	completeStatus: "staffAuthorization.enableCompleteStatus",
	setting: "staffAuthorization.enableSetting",
	status: "staffAuthorization.enableStatus"
} as const satisfies Record<
	"setting" | "status" | "completeStatus" | "cancel",
	string
>;

export const hasAuthorization = (
	account: ItandiAccount,
	authType: AuthorizationType
): boolean =>
	(account.isAdmin || account.staff?.staffAuthorization[authType]) ?? false;
